import {Component, Inject, OnInit} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiService} from './shared/services/api.service';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {InternalService} from './shared/services/internal.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {Title} from '@angular/platform-browser';
// import * as jwt_decode from 'jwt-decode';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // title = 'Elimedi Admin panel';

  constructor(private title: Title,
              private apiService: ApiService,
              @Inject(SESSION_STORAGE) private session: WebStorageService,
              public internalService: InternalService,
              private router: Router,
              private cookieService: CookieService,
              public translete: TranslateService,
              public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {
  }


  ngOnInit() {
    if(this.apiService.currentDirection == 'rtl'){
      this.title.setTitle('ایلایمدی');
    }else{
      this.title.setTitle('Elimedi');
    }


    this.apiService.RegisterConfirm().subscribe((response: any) => {
      console.log('RegisterConfirm',response);
      this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
      this.cookieService.set('fullName', response.res.name);
     // console.log(this.oidcSecurityService.getToken());
     //  debugger
      const token =this.oidcSecurityService.getToken();
      console.log(token);

     // var decoded = jwt_decode(token, { header: true });
     // console.log('tessssssssssssssssss2222222222222t',decoded);
    //   this.oidcSecurityService.getClaims(): any {
    //   return this.user.profile;
    // }
   //   var givenName = decoded['NickName'];
   //   console.log(givenName, 'givenName');

     // console.log('decoded===========================' + JSON.stringify(decoded));
      // this.getDecodedAccessToken(this.oidcSecurityService.getToken().split('.')[1]);
    })


    if (this.cookieService.get('dir') === 'rtl' || this.cookieService.get('dir') == null) {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('fa-ir');
      // this.title.setTitle('الوبدو');
    } else {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('en-us');
      // this.title.setTitle('Alobodo');
    }


  }

  login() {
    this.oidcSecurityService.authorize();
  }



  changeLang(language) {
    this.internalService.changeLang(language, 0);
  }

}
